import React from 'react';
import { transformationSteps } from '../data/content';
export function Process() {
  return <section id="process" className="w-full bg-sand py-20 lg:py-28" data-id="element-507" data-mp="1uddafw38xqm9">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-508" data-mp="1ufg72yywmhzy">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-16" data-id="element-509" data-mp="1ygi89lcdt44k">
          <div data-id="element-510" data-mp="23d8p4aw0g3r1">
            <p className="text-sm font-semibold text-sky-600" data-id="element-511" data-mp="23druyt8dz1op">From cracked to resort-worthy</p>
            <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight text-navy-800 sm:text-4xl" data-id="element-512" data-mp="16pc6z1kxd0dp">
              In 3–4 weeks, your pool looks brand new.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-navy-500" data-id="element-513" data-mp="1fnxkgibjhp7m">
              Not just clean — transformed. The plaster is smooth and vibrant, the color is exactly
              what you wanted, the tile gleams, the edges are crisp.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-navy-500" data-id="element-514" data-mp="ryv55h4do8ga">
              Your guests walk into the backyard and their faces light up.{' '}
              <span className="font-semibold text-navy-800" data-id="element-515" data-mp="19kpsqzbc1s6i">
                &ldquo;Wow — when did you do this?&rdquo;
              </span>
            </p>
            <figure className="mt-8 hidden lg:block" data-id="element-516" data-mp="10se0d7wnrunw">
              <img src="https://cdn.magicpatterns.com/uploads/xs8kJWtHGekmbppCz2Q5s8/aj13.png" alt="A&J crew troweling fresh white plaster inside a drained backyard pool on a sunny day" className="w-full rounded-lg object-cover" data-id="element-517" data-mp="10r2vf4rh8gv7" />
              <figcaption className="mt-3 text-[13px] leading-snug text-navy-400" data-id="element-518" data-mp="lvwqkl44ao3g">
                Our own crew applying the finish coat — the same people you meet at the estimate
                are the ones in your pool.
              </figcaption>
            </figure>
          </div>

          <ol className="relative" data-id="element-519" data-mp="cxb96tadtf49">
            {transformationSteps.map((item, index) => <li key={item.step} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-520" data-mp="2c7b1hg64aabm" data-mpi={index}>
                {index < transformationSteps.length - 1 && <span aria-hidden="true" className="absolute left-[19px] top-11 h-[calc(100%-2.75rem)] w-px bg-navy-200" data-id="element-521" data-mp="2qdmjthd9kaus" />}
                <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy-800 font-display text-sm font-bold text-white" data-id="element-522" data-mp="2v4l1oldwhh05">
                  {index + 1}
                </span>
                <div className="pt-1" data-id="element-523" data-mp="2mcsuqko34q0b">
                  <p className="text-xs font-bold uppercase tracking-[0.16em] text-sky-600" data-id="element-524" data-mp="2m9n3ozvwbe1y">
                    {item.step}
                  </p>
                  <h3 className="mt-1.5 font-display text-xl font-bold text-navy-800" data-id="element-525" data-mp="3e25qjsgo0fkr">
                    {item.title}
                  </h3>
                  <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-navy-400" data-id="element-526" data-mp="305ih4q7izwxy">
                    {item.body}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}